import _ from 'lodash'
import { message } from 'antd'
import { Action, Reducer, ReducersMapObject } from 'redux'
import {
  Model,
  Effect,
  Subscription,
  SubscriptionAPI,
  SubscriptionsMapObject,
  EffectsMapObject,
  EffectWithType,
  EffectsCommandMap,
} from 'dva'
import pathToRegexp from 'path-to-regexp'

// @ts-ignore

interface EnterRouteMaps {
  [index: string]: boolean
}

const enterRouteMaps: EnterRouteMaps = {}

interface ListenMaps {
  [index: string]: Function
}

const listenMaps: ListenMaps = {}

export interface EnhanceSubscriptionAPI extends SubscriptionAPI {
  listen: (pathReg: string, handleEnter?: Function, handleLeave?: Function) => void
}

export interface EnHanceEffectsCommandMap extends EffectsCommandMap {
  callWithMessage: Function
}

export type EnHanceEffect = (action: Action, effects: EnHanceEffectsCommandMap) => void

export interface EnhanceSubscriptionMap {
  [key: string]: (api: EnhanceSubscriptionAPI, done: Function) => void
}

export interface EnhanceEffectsMap {
  [key: string]: EnHanceEffect | EffectWithType
}

export interface ModelWithState<T = any> extends Model {
  state?: T
}

export interface EnhanceModel<T> {
  namespace: string
  state: T
  subscriptions: EnhanceSubscriptionMap
  effects: EnhanceEffectsMap
  reducers: {
    [propName: string]: Reducer<T>
  }
}

// effect 添加 catch 捕捉 ，新增effect方法 callWithMessage
const createCatchEffect = (effectFn: EnHanceEffect | EffectWithType): Effect => {
  return function*(action: Action, effects: EffectsCommandMap) {
    try {
      const { call } = effects
      const callWithMessage = function*(
        fn: Function,
        params: any,
        successMessage: string,
        errorMessage: string
      ) {
        const result = yield call(fn, params)
        if (!result.code) {
          message.success(successMessage || result.message || '操作成功')
        } else {
          // message.error(result.message || errorMessage || '操作失败');
        }
        return result
      }
      const result = yield call(effectFn, action, { ...effects, callWithMessage })
      return result
    } catch (error) {
      console.log(error)
      // if (error.message) {
      //   message.error(error.message, 3);
      // }
      return null
    }
  }
}

// 添加路由监听方法
const enhanceSubscriptions = (subscriptions: EnhanceSubscriptionMap): SubscriptionsMapObject => {
  return Object.keys(subscriptions).reduce((cache, key) => {
    cache[key] = createListenSub(subscriptions[key])
    return cache
  }, {})
}

// subscriptions 添加 listen 方法,监听路由进入 与 离开
const createListenSub = (
  subscription: (api: EnhanceSubscriptionAPI, onError: Function) => void
): Subscription => {
  return ({ dispatch, history }: SubscriptionAPI, onError: Function) => {
    // 标志是否进入该路由
    const listen = (pathReg: string, handleEnter?: Function, handleLeave?: Function) => {
      // 移除原有监控
      if (listenMaps[pathReg]) {
        listenMaps[pathReg]()
      }
      listenMaps[pathReg] = history.listen(({ pathname }) => {
        const match = pathToRegexp(pathReg).exec(pathname)
        if (match) {
          enterRouteMaps[pathReg] = true
          if (handleEnter) {
            handleEnter({ match })
          }
        } else if (enterRouteMaps[pathReg]) {
          enterRouteMaps[pathReg] = false
          if (handleLeave) {
            handleLeave()
          }
        }
      })
    }
    subscription({ dispatch, history, listen }, onError)
  }
}

// 添加通用reducer, setState 与 resetState
const enhanceReducer = (reducers: ReducersMapObject, model: EnhanceModel<any>) => {
  return {
    setState(state: any, { payload }: Action) {
      return {
        ...state,
        ...payload,
      }
    },
    resetState() {
      const initialState = _.cloneDeep(model.state)
      return {
        ...initialState,
      }
    },
    ...reducers,
  }
}

const enhanceEffects = (effects: EnhanceEffectsMap): EffectsMapObject => {
  return Object.keys(effects).reduce((cache, key) => {
    cache[key] = _.isArray(effects[key]) ? effects[key] : createCatchEffect(effects[key])
    return cache
  }, {})
}

const extend = (model: EnhanceModel<any>): Model => {
  const { namespace, state, subscriptions = {}, effects, reducers } = model
  return {
    namespace,
    state,
    subscriptions: enhanceSubscriptions(subscriptions),
    effects: enhanceEffects(effects),
    reducers: enhanceReducer(reducers, model),
  }
}

export default {
  extend,
}
